module.exports = __webpack_public_path__ + "img/settings.22e86568.svg";